<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
:root {
  box-sizing: border-box;
  --dunkelblau: #1f304f;
  --normalblau: #0048e8;
  --stripe-one: #606dbc;
  --stripe-two: #465298;
  --hellblau: #5474a7;
  --my-gradient: linear-gradient(to bottom, #1f304f, #2a529c);
  --my-gradient-two: linear-gradient(to right, #a2bbe3, #d2dced);
}
#app {
  font-family: courier, courier new, serif;
  font-family: Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  background-color: #221f21;
  background-color: #fff;
  height: 100vh;
  color: #221f21;
  display: flex;
  flex-direction: column;
}
</style>
